import * as React from 'react';
import { Field } from 'react-final-form';
import AnimateHeight from 'react-animate-height';

interface IFormTextArea {
    name: string;
    label?: string;
    isDisabled?: boolean;
    isRequired?: boolean;
    className?: string;
    style?: React.CSSProperties;
    error?: string;
    tabIndex?: number;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onEnter?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    width?: string;
    height?: string;
    id?: string;
    resize?: 'none' | 'vertical';
}

const FormTextArea = (props: IFormTextArea) => {
    return (
        <Field name={props.name}>
            {({ input, meta }) => {
                const hasError = meta.submitFailed && meta.error;

                let labelClass = input.value ? 'reduced ' : ' ';
                labelClass += props.isRequired ? 'required ' : '';
                labelClass += hasError ? 'error' : '';
                const inputClass = hasError ? 'error ' : '';
                const errorHeight = hasError ? 'auto' : 0;

                const style = {
                    ...props.style,
                    width: props.width,
                    height: props.height,
                    resize: props.resize || 'none',
                };

                return (
                    <div className={`dlc-form-textarea-wrapper ${props.className || ''}`} style={props.style}>
                        <div className="dlc-form-textarea">
                            <textarea
                                id={props.id || undefined}
                                className={`dlc-form-textarea-input ${inputClass}`}
                                tabIndex={props.tabIndex}
                                {...input}
                                style={style}
                                onChange={(e) => {
                                    input.onChange(e);
                                    if (props.onChange) {
                                        props.onChange(e);
                                    }
                                }}
                                // autoComplete={'new-password'}
                                disabled={props.isDisabled || false}
                            />
                            <div className={`dlc-form-textarea-label ${labelClass}`}>{props.label}</div>
                        </div>
                        <AnimateHeight height={errorHeight} duration={300}>
                            <div className="dlc-form-textarea-error">{meta.error}</div>
                        </AnimateHeight>
                    </div>
                );
            }}
        </Field>
    );
};

export default FormTextArea;



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/FormTextArea.tsx